import AccountSettingsTemplate from "components/templates/AccountSettingsTemplate/AccountSettingsTemplate";

const AccountSettingsPage = () => {
  return <AccountSettingsTemplate />;
};

export default AccountSettingsPage;
